/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import {IHttpService, ILogService, IPromise} from 'angular';
import TSWorkJob from '../../models/TSWorkJob';

/**
 * liest information ueber batch jobs aus
 */
export default class BatchJobRS {
    public static $inject = ['$http', 'REST_API', '$log'];

    public serviceURL: string;

    public constructor(
        public http: IHttpService,
        REST_API: string,
        private $log: ILogService
    ) {
        this.serviceURL = `${REST_API}admin/batch`;
    }

    public getAllJobs(): IPromise<TSWorkJob[]> {
        return this.getInfo(`${this.serviceURL}/jobs`);
    }

    public getBatchJobsOfUser(): IPromise<TSWorkJob[]> {
        return this.getInfo(`${this.serviceURL}/userjobs/notokenrefresh`);
    }

    public getBatchJobInformation(executionId: string): IPromise<TSWorkJob[]> {
        return this.getInfo(`${this.serviceURL}/jobs/${encodeURI(executionId)}`);
    }

    private getInfo(url: string): IPromise<Array<TSWorkJob> | never> {
        return this.http.get(url).then((response: any) => {

            if (response.data !== undefined) {
                this.$log.debug('PARSING WorkJob REST  object', response.data);
                return TSWorkJob.deserializeArray(response.data.jobs);
            } else {
                return [];
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/service/batchRS.rest.ts